import {formattedPropertyModel, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './ChangeItemHeader.less';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

const I18N = defineMessages({
  COLLAPSE: {
    id: 'common.changeItemExpandButton.collapse',
    defaultMessage: 'Collapse data',
    description: 'title text for collapse data button',
  },
  EXPAND: {
    id: 'common.changeItemExpandButton.expand',
    defaultMessage: 'Expand data',
    description: 'title text for expand data button',
  },
});

const CHANGE_USERNAME = 'username';
const CHANGE_DATE = 'date';

const ChangeItemHeader = ({data, disabled, handleExpand, intl, isExpanded}) => {
  const itemData = data[KEYWORD_PROP_CONTENT_VALUE];
  const propDefinition = new formattedPropertyModel.FormattedProperty({
    type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_DATETIME,
  });
  const username = itemData[CHANGE_USERNAME][KEYWORD_PROP_CONTENT_VALUE];
  const date = formattedPropertyModel.FormattedProperty.formatValue(
    propDefinition,
    itemData[CHANGE_DATE][KEYWORD_PROP_CONTENT_VALUE],
    intl
  );

  const handleClick = (event) => {
    event.stopPropagation();
    if (disabled) {
      event.preventDefault();
    } else {
      handleExpand();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      if (disabled) {
        event.preventDefault();
      } else {
        handleExpand();
      }
    }
    return true;
  };

  return (
    <div
      className={classNames(styles.dlChangeItemHeader, {
        [styles.dlDisabled]: disabled,
      })}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
      role={'button'}
      title={utils.TranslateUtils.translate(
        isExpanded ? I18N.COLLAPSE : I18N.EXPAND,
        intl
      )}
    >
      <span className={styles.dlChangeItemHeaderContent}>
        <span className={styles.dlChangeItemGroupNoWrap}>
          <i className={classNames(styles.dlChangeItemIcon, 'far fa-user')} />
          <span className={styles.dlChangeItemUsername}>{username}</span>
        </span>
        <span className={styles.dlChangeItemGroupNoWrap}>
          <i className={classNames(styles.dlChangeItemIcon, 'far fa-clock')} />
          <span className={styles.dlChangeItemDate}>{date}</span>
        </span>
      </span>
      <i
        className={classNames(styles.dlChangeItemExpandDataIcon, 'fas', {
          'fa-angle-up': isExpanded,
          'fa-angle-down': !isExpanded,
        })}
      />
    </div>
  );
};

ChangeItemHeader.displayName = 'ChangeItemHeader';

ChangeItemHeader.propTypes = {
  handleExpand: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

ChangeItemHeader.defaultProps = {
  data: {},
};

export default injectIntl(ChangeItemHeader);
